<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">360 Sections</h1>
                </div>

                <!--<div class="card shadow">-->

                <div class="topSpacing">
                    <div class="desktopTabs">
                        <ul class="tab-nav">
                            <li (click)="tabSelect(0)" class="active"><a data-toggle="tab" href="#tab1">Section 1</a></li>
                            <li (click)="tabSelect(1)"><a data-toggle="tab" href="#tab2">Section 2</a></li>
                        </ul>
                    </div>

                    <div class="main-tab-content tab-content">
                        <div id="tab1" class="tab-pane fade in active">
                            <app-section1></app-section1>
                        </div>

                        <div id="tab2" class="tab-pane fade">
                            <app-section2></app-section2>
                        </div>
                    </div>
                </div>

                <!--</div>-->
            </div>
        </div>
    </div>
</div>